import React from "react";
import "./Loader.css"; // Create a separate CSS file for styling

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
